import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          registrarId: Yup.string(),
                                          category: Yup.string()
                                      });
